import React, { useState, useCallback } from 'react';

import { Tab } from '@mui/material';
import PageWrapper from 'templates/PageWrapper/PageWrapper';

import { StyledPaper } from 'pages/ContactsPage/Contacts.styles';
import { TabContext, TabPanel } from '@mui/lab';
import { StyledTabList } from 'molecules/Card/Card.styles';
import { StyledTabPanel } from 'organisms/CompanyInvoicesTabs/CompanyInvoicesTabs.styles';
import LogsBlock from 'organisms/Logs/Logs';
import ActivityLogsBlock from 'organisms/Logs/ActivityLogs';

type TabType = 'notifications' | 'logs';
export type filterApplyType = {
  date_from: string;
  date_to: string;
  type: string;
};

const LogsPage = () => {
  const [selectedTab, setSelectedTab] = useState<TabType>('notifications');

  const handleChangeTabs = useCallback(
    (event: React.SyntheticEvent, newValue: TabType) => {
      setSelectedTab(newValue);
    },
    []
  );

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  return (
    <PageWrapper title="Logs" isRelative>
      <StyledPaper sx={{ minWidth: '1150px !important' }}>
        <TabContext value={selectedTab}>
          <StyledTabList
            onChange={handleChangeTabs}
            aria-label="Projects-invoicing and Sales Reports tabs"
            variant="fullWidth"
          >
            <Tab
              label="Notifications"
              {...a11yProps(1)}
              className={selectedTab === 'notifications' ? '.active' : ''}
              value="notifications"
            />
            <Tab
              label="Activity Logs"
              {...a11yProps(0)}
              className={selectedTab === 'logs' ? '.active' : ''}
              value="logs"
            />
          </StyledTabList>
          <StyledTabPanel value="notifications" sx={{ p: 0 }}>
            <LogsBlock />
          </StyledTabPanel>
          <TabPanel value="logs" sx={{ p: 0 }}>
            <ActivityLogsBlock />
          </TabPanel>
        </TabContext>
      </StyledPaper>
    </PageWrapper>
  );
};

export default LogsPage;
